import { useNavigate } from 'react-router-dom';

import {
  // EstadoOLTOptions,
  gridSizeMdLg12,
  gridSizeMdLg6,
  ROUTER_PATHS,
  useCheckPermissionsArray,
  useLoaders,
} from '@/shared';
import {
  CustomTextField,
  SingleFormBoxScene,
} from '@/shared/components/ui';
import {
  Contrato,
  EstadosNavegacionEnum,
} from '@/shared/interfaces';
// import { useUiStore } from '@/store/ui';
import { useForm } from 'react-hook-form';
import { SAVE_RAD_CHECK_PERMISSIONS } from '../../constants';
import { Button, Grid } from '@mui/material';
import { CustomAlertCard } from '@/shared/components/ui/Alerts';
import { usePostActivacionesRadius } from '@/shared/actions/erp';
import { toast } from 'react-toastify';
import { useEffect } from 'react';


export interface SaveRadCheckComponentProps {
  title: string;
  contrato?: Contrato;
}

type SaveFormData = {
  razon_social?:string,
  identificacion?: string,
  pppoe?: string,
  pppassword?: string,
  ipv4_actual?: string,
  ipv4?: string,
  fecha_instalacion?: string;
  estado_navegacion?: EstadosNavegacionEnum

  olt?: string
  nodo?: string
  caja_primaria?: string
  nap?: string
  bras?: string
  router?: string;
} 

const SaveRadCheckComponent: React.FC<SaveRadCheckComponentProps> = ({ 
  title, contrato }) => {
  useCheckPermissionsArray(SAVE_RAD_CHECK_PERMISSIONS);

  const returnUrlServicioClientesPage = ROUTER_PATHS.administration.radCheckNav;
  const navigate = useNavigate();

  ///* form
  const form = useForm<SaveFormData>({
    // resolver: yupResolver(oltFormSchema as any),
  });

  const {
    // control,
    // handleSubmit,
    formState: { errors },
    reset,
  } = form;


  ///* store
  // const setAlert = useUiStore(s => s.setAlert);

  const {
    mutateAsync: postActivacionesRadius,
    isPending: pendingActivacionesRadius,
  } = usePostActivacionesRadius({
    navigate,
    returnUrl: returnUrlServicioClientesPage,
    customMessageErrorAlert:"Error al crear el registro de Radius, por favor, intente nuevamente."
  })
  // const { 
  //   mutateAsync: updateContrato,
  //   isPending: pendingContratoUpdate
  // } = useUpdateContrato<Pick<Contrato,"estado_navegacion">>({
  //   navigate,
  //   returnUrl: returnUrlServicioClientesPage,
  // })



  ///* handlers
  // const onActivate = async () => {
  //     updateContrato({
  //       id: contrato?.id_contrato!,
  //       data:{
  //         estado_navegacion: EstadosNavegacionEnum.ACTIVO
  //       }
  //     })
  // }
  // const onReactivate = async () => {
  //   if (!!!form.getValues().pppoe){
  //     return toast.error("No se pudo obtener el PPPoE")
  //   }
  //   if (!!!form.getValues().ipv4){
  //     return toast.error("No se pudo obtener la IPv4")
  //   }
  //   updateContrato({
  //     id: contrato?.id_contrato!,
  //     data:{
  //       estado_navegacion: EstadosNavegacionEnum.REACTIVADO
  //     }
  //   })
  // }
  // const onSuspend = async () => {
  //   if (!!!form.getValues().pppoe){
  //     return toast.error("No se pudo obtener el PPPoE")
  //   }
  //   updateContrato({
  //     id: contrato?.id_contrato!,
  //     data:{
  //       estado_navegacion: EstadosNavegacionEnum.SUSPENDIDO
  //     }
  //   }) 
  // }
  const onSaveNew = async () => {
    if (!!!form.getValues().pppoe){
      return toast.error("No se pudo obtener el PPPoE")
    }
    if (!!!form.getValues().pppassword){
      return toast.error("No se pudo obtener el PPPassword")
    }
    if (!!!form.getValues().ipv4){
      return toast.error("No se pudo obtener el IPv4 Actual")
    }

    postActivacionesRadius({
      type_request:"SET",
      pppoe: form.getValues().pppoe!,
      pppassword: form.getValues().pppassword!,
      ipv4_actual: form.getValues().ipv4
    }) 
  }

  useEffect(() => {
    if(!!contrato){
      reset({
        razon_social: contrato?.cliente_data?.razon_social,
        identificacion: contrato?.cliente_data?.identificacion,
        fecha_instalacion: contrato?.orden_trabajo_data?.fecha_instalacion,
        estado_navegacion: contrato?.estado_navegacion,
        bras: contrato?.bras as string,
        router: contrato?.router as string,
        olt: contrato?.olt_data?.nombre || contrato?.olt as string,
        nodo: contrato?.nodo_data?.nombre || contrato?.nodo as string,
        caja_primaria: contrato?.caja_primaria as string || contrato?.nap_data?.caja_primaria,
        nap: contrato?.nap_data?.nombre || contrato?.nap as string,
        pppoe: contrato?.pppoe || contrato?.orden_trabajo_data?.pppoe,
        pppassword: contrato?.pppassword || contrato?.orden_trabajo_data?.pppassword,
        ipv4_actual:contrato?.ipv4_actual as string,
        ipv4:contrato?.ipv4_actual as string,
      })
    }
    
  }, [contrato]);




  useLoaders(pendingActivacionesRadius)
  return (
    <SingleFormBoxScene
      titlePage={title}
      // onCancel={() => navigate(returnUrlServicioClientesPage)}
      // onSave={handleSubmit(()=>alert("Guardado"), (errors) => {
      //   setAlert(true, 'Campos sin llenar', AlertSeverityEnum.error)
      //   console.log('errors', errors);
      // })}
      showActionBtns={false}
      showCustomBtns
      customBtns={
        <Grid container item justifyContent={"end"} gap={2} >
          <Button onClick={()=> navigate(returnUrlServicioClientesPage)}
          variant="outlined" color='primary'>
            Regresar
          </Button>
          {
            !contrato &&
            <Button onClick={onSaveNew}
            variant="contained" color='primary'>
              Guardar
            </Button>
          }
          {/* {
            (contrato?.estado_navegacion==EstadosNavegacionEnum.ACTIVO 
            || contrato?.estado_navegacion==EstadosNavegacionEnum.AUDITADO)&&
            <Button onClick={onSuspend}
            variant="contained" color='warning'>
              Suspender
            </Button>
          }
          {
            (contrato?.estado_navegacion==EstadosNavegacionEnum.DESCONECTADO
              || contrato?.estado_navegacion==EstadosNavegacionEnum.SUSPENDIDO
            ) &&
            <Button onClick={onReactivate}
            variant="contained" color='success'>
              Reactivar
            </Button>
          }
          {
            contrato?.estado_navegacion==EstadosNavegacionEnum.EN_ESPERA &&
            <Button onClick={onActivate}
            variant="contained" color='success'>
              Activar
            </Button>
          } */}
          {/* 
          // ===================================================================
          // Para probar sin validaciones
          // =================================================================== */}
          
            {/* <Button onClick={onSuspend}
            variant="contained" color='warning'>
              Suspender
            </Button>
            <Button onClick={onReactivate}
            variant="contained" color='success'>
              Reactivar
            </Button>
            <Button onClick={onActivate}
            variant="contained" color='success'>
              Activar
            </Button> */}
        </Grid>
      }
    >
      {contrato && <CustomAlertCard
      alertColor='info'
      alertTitle="Estado de Navegación"
      alertMessage={form.getValues().estado_navegacion|| contrato?.estado_navegacion} 
      bgColorAlert={
        form.getValues().estado_navegacion==EstadosNavegacionEnum.ACTIVO?
        "GREEN"
        :form.getValues().estado_navegacion==EstadosNavegacionEnum.DESCONECTADO 
        || form.getValues().estado_navegacion==EstadosNavegacionEnum.SUSPENDIDO ?
        "RED"
        :form.getValues().estado_navegacion==EstadosNavegacionEnum.EN_ESPERA?
        "SKY"
        :"GRAY"
      }/>}
      {
        contrato && (<>
          <CustomTextField
            label="Cliente"
            name="nombre"
            control={form.control}
            defaultValue={form.getValues().razon_social|| contrato?.cliente_data?.razon_social}
            error={errors.razon_social}
            helperText={errors.razon_social?.message}
            disabled={true}
            size={gridSizeMdLg12}
          />

          <CustomTextField
            label={'Identificación'}
            name="identificacion"
            defaultValue={form.getValues().identificacion|| contrato?.cliente_data?.identificacion}
            control={form.control}
            error={errors.identificacion}
            helperText={errors.identificacion?.message}
            disabled={true}
            size={gridSizeMdLg6}
          />
          <CustomTextField
            label={'Fecha Instalación'}
            name="fecha_instalacion"
            defaultValue={form.getValues().fecha_instalacion || contrato?.orden_trabajo_data?.fecha_instalacion}
            control={form.control}
            error={errors.fecha_instalacion}
            helperText={errors.fecha_instalacion?.message}
            disabled={true}
            size={gridSizeMdLg6}
          />
          {/* 
          // =======================================================================
          // datos de conexión
          // =======================================================================
          */}
          {
            form.getValues().bras || contrato?.bras?
            <CustomTextField
              label={'BRAS'}
              name="bras"
              defaultValue={form.getValues().bras || contrato?.bras  } //contrato?.bras
              control={form.control}
              error={errors.bras}
              helperText={errors.bras?.message}
              disabled={true}
              size={gridSizeMdLg12}
            />
            :form.getValues().router || contrato?.router?
            <CustomTextField
              label={'Router'}
              name="router"
              defaultValue={form.getValues().router || contrato?.router}
              control={form.control}
              error={errors.router}
              helperText={errors.router?.message}
              disabled={true}
              size={gridSizeMdLg12}
            />
            :<>
              <CustomAlertCard
              alertColor="warning"
              alertTitle="Servicio no habilitado"
              alertMessage={"Aún no se tiene ROUTER o BRAS asignado"} 
              bgColorAlert={
                form.getValues().estado_navegacion==EstadosNavegacionEnum.ACTIVO?
                "GREEN"
                :form.getValues().estado_navegacion==EstadosNavegacionEnum.DESCONECTADO?
                "RED"
                :form.getValues().estado_navegacion==EstadosNavegacionEnum.EN_ESPERA?
                "SKY"
                :"GRAY"
              }/>
            </>

          }
          <CustomTextField
            label={'OLT'}
            name="olt"
            defaultValue={form.getValues().olt || contrato?.olt}
            control={form.control}
            error={errors.olt}
            helperText={errors.olt?.message}
            disabled={true}
            size={gridSizeMdLg6}
          />
          <CustomTextField
            label={'Nodo'}
            name="nodo"
            defaultValue={form.getValues().nodo || contrato?.nodo}
            control={form.control}
            error={errors.nodo}
            helperText={errors.nodo?.message}
            disabled={true}
            size={gridSizeMdLg6}
          />
          
          <CustomTextField
            label={'Manga'}
            name="caja_primaria"
            defaultValue={form.getValues().caja_primaria || contrato?.caja_primaria} //|| contrato?.caja_primaria
            control={form.control}
            error={errors.caja_primaria}
            helperText={errors.caja_primaria?.message}
            disabled={true}
            size={gridSizeMdLg6}
          />
          <CustomTextField
            label={'Caja Secundaria'}
            name="nap"
            defaultValue={form.getValues().nap || contrato?.nap}
            control={form.control}
            error={errors.nap}
            helperText={errors.nap?.message}
            disabled={true}
            size={gridSizeMdLg6}
          />
        </>)
      }
      <CustomTextField
        label={'PPPoE'}
        name="pppoe"
        defaultValue={form.getValues().pppoe || contrato?.pppoe || contrato?.orden_trabajo_data?.pppoe}
        control={form.control}
        error={errors.pppoe}
        helperText={errors.pppoe?.message}
        disabled={contrato?true:false}
        size={gridSizeMdLg6}
        overrideAsPassword
      />
      <CustomTextField
        label={'PPPassword'}
        name="pppassword"
        defaultValue={form.getValues().pppassword || contrato?.pppassword || contrato?.orden_trabajo_data?.pppassword}
        control={form.control}
        error={errors.pppassword}
        helperText={errors.pppassword?.message}
        disabled={contrato?true:false}
        size={gridSizeMdLg6}
        overrideAsPassword
      />
      <CustomTextField
        label={'IPv4'}
        name="ipv4"
        defaultValue={form.getValues().ipv4 || contrato?.ipv4_actual }
        control={form.control}
        error={errors.ipv4}
        helperText={errors.ipv4?.message}
        disabled={contrato?true:false}
        size={gridSizeMdLg12}
        overrideAsPassword
      />
    </SingleFormBoxScene>
  );
};

export default SaveRadCheckComponent;
